module.exports = __webpack_public_path__ + "static/media/master.159b3af1.svg";